import React from "react";
import {
  AppBar,
  Badge,
  Box,
  Button,
  Container,
  IconButton,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import { ArrowLeft, ShoppingCart, Store, User } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { brand } from "../data/estoreContent";
import { ESTORE_ROUTES } from "../data/estorePaths";
import { useEstoreCart } from "../hooks/useEstoreCart";

/**
 * Inner-page header: keeps users inside Estore routes only.
 */
function EstoreChrome({ title, showBack }) {
  const navigate = useNavigate();
  const { count } = useEstoreCart();

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: "rgba(255,255,255,0.94)",
        backdropFilter: "blur(10px)",
        borderBottom: `1px solid ${brand.stroke}`,
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ py: 1, gap: 2 }}>
          {showBack && (
            <IconButton onClick={() => navigate(-1)} aria-label="Back" sx={{ color: brand.text }}>
              <ArrowLeft />
            </IconButton>
          )}
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{ cursor: "pointer", flexGrow: showBack ? 0 : 1 }}
            onClick={() => navigate(ESTORE_ROUTES.home)}
          >
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: 2,
                display: "grid",
                placeItems: "center",
                background: `linear-gradient(135deg, ${brand.accent} 0%, ${brand.accent2} 100%)`,
              }}
            >
              <Store size={18} color="#fff" />
            </Box>
            <Typography variant="subtitle1" fontWeight={800} sx={{ color: brand.text }}>
              {brand.name}
            </Typography>
          </Stack>
          {title && (
            <Typography variant="body1" sx={{ color: brand.muted, flex: 1, minWidth: 0, fontWeight: 600 }} noWrap>
              {title}
            </Typography>
          )}
          <Button onClick={() => navigate(ESTORE_ROUTES.shop)} sx={{ color: brand.text, fontWeight: 700, textTransform: "none", display: { xs: "none", sm: "inline-flex" } }}>
            Shop
          </Button>
          <IconButton onClick={() => navigate(ESTORE_ROUTES.cart)} aria-label="Cart" sx={{ color: brand.text }}>
            <Badge badgeContent={count} color="primary" max={99} invisible={count === 0}>
              <ShoppingCart size={22} />
            </Badge>
          </IconButton>
          <IconButton onClick={() => navigate(ESTORE_ROUTES.account)} aria-label="Account" sx={{ color: brand.text }}>
            <User size={22} />
          </IconButton>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default EstoreChrome;
